<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Νεο παραστατικό</span>
        </v-card-title>

        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
              
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
              
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
     
        </v-dialog>
        <!-- ΒΑΣΙΚΑ ΣΤΟΙΧΕΙΑ -->

        <v-window v-model="step">
            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Βασικά στοιχεία</h3>
                    
                    <v-select 
                        v-bind:items="documentTypes" 
                        v-model="selectedDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-select 
                        v-show="selectedDocumentType.series.length > 1 || (selectedSeries.name && selectedSeries.name.length > 0)"
                        v-bind:items="selectedDocumentType.series"
                        v-model="selectedSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού"
                        v-bind:error-messages="allerrors.document_series">
                    </v-select>

                    <v-text-field 
                        v-if="selectedSeries.autonumbered == false"
                        v-model.number="document_number" 
                        label="Αριθμός παραστατικού"
                        v-bind:error-messages="allerrors.document_series"
                        v-bind:disabled="selectedSeries.autonumbered">
                    </v-text-field>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>

                </v-card-text>
            </v-window-item>






            <!-- ΠΕΛΑΤΗΣ -->

            <v-window-item :value="1">
                <v-card-text>
                    <v-row>
                        <h3 class="text-h6 font-weight-light mb-2">Στοιχεία πελάτη</h3>
                        <v-spacer></v-spacer>
                        <v-btn text color="warning" v-on:click="clearSupplierFields">ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-row>
        
                    <v-text-field 
                        v-bind:disabled="supplierNotEditable"
                        v-model="supplier.name" 
                        label="Επωνυμία"
                        append-icon="mdi-account-search"
                        @click:append="searchAccountByName('supplier')"
                        v-bind:error-messages="allerrors.supplier.name">
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:disabled="supplierNotEditable"
                                v-model="supplier.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByTaxRegistrationNumber('supplier')"
                                v-bind:error-messages="allerrors.supplier.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                disabled
                                v-model="supplier.tax_office.name"
                                label="ΔΟΥ"
                                v-bind:error-messages="allerrors.supplier.tax_registration_office_id">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                disabled
                                v-model="supplier.country.name_gr"
                                label="Χώρα" 
                                v-bind:error-messages="allerrors.supplier.country_id">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field
                                disabled
                                v-model="supplier.city"
                                label="Πόλη"
                                v-bind:error-messages="allerrors.supplier.city">
                            </v-text-field>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                disabled
                                v-model="supplier.address" 
                                label="Διεύθυνση"
                                v-bind:error-messages="allerrors.supplier.address">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                disabled
                                v-model="supplier.zipcode" 
                                label="ΤΚ"
                                v-bind:error-messages="allerrors.supplier.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:disabled="supplierNotEditable"
                                v-model="supplier.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.supplier.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:disabled="supplierNotEditable"
                                v-model="supplier.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.supplier.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                disabled
                                v-model="supplier.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:error-messages="allerrors.supplier.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                disabled
                                v-model="supplier.email" 
                                label="E-Mail"
                                v-bind:error-messages="allerrors.supplier.email">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>


            <v-window-item :value="2">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4"> Οικονομικά </h3>

                    <v-select 
                        v-bind:items="paymentTypes" 
                        v-model="selectedPaymentType"
                        return-object

                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                    <vuetify-money
                        v-model="document_gross_value"
                        label="Μικτό ποσό"
                        v-bind:options="moneyFieldOptions">
                    </vuetify-money>

                    <v-checkbox
                      v-model="if_payback"
                      label="Αφορά εξόφληση παραστατικών">
                    </v-checkbox>
                </v-card-text>

            </v-window-item>


            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παρατηρήσεις - Σχόλια</h3>

                    <v-textarea
                        v-model="comments"
                        label="Σχόλια">
                    </v-textarea>
                    
                </v-card-text>
            </v-window-item>

            <v-window-item :value="4">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Σύνοψη παραστατικού</h3>
                    
                    <v-text-field
                        disabled 
                        v-model="selectedDocumentType.description" 
                        label="Παραστατικό">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="supplier.name" 
                        label="Εντολέας">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="document_gross_value" 
                        label="Συνολικό ποσό">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="selectedPaymentType.description" 
                        label="Τρόπος πληρωμής">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>
        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        
                        @click="toggle">
                        <v-icon>mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="step++;">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>

export default {
    data () {
        return {
            
            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 8,
                precision: 2
            },

            step: 0,
            totalSteps: 5,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            allerrors : {
                supplier: {},
             },

            supplier: {
                country: {},
                tax_office: { },

            },

            documentTypes: [],
            documentSeries: [],
            paymentTypes: [],

            selectedDocumentType: {
                series: []
            },
            selectedSeries: {},
            selectedPaymentType: {},

            document_number: '',
            document_issue_date: '',
            document_gross_value: '',



            if_payback: false,

            comments: '',

            menu2: false,

            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',


        }
    },

    created() {
        this.initialize()
    },

    watch: {
        selectedDocumentType: function (val) {
            this.document_number = ''
            this.selectedSeries = {}


            if (this.selectedDocumentType.series.length == 1)
                this.selectedSeries = this.selectedDocumentType.series[0]


        },


    },

    computed: {
        selectedDocumentDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        stepCompleted() {
            switch (this.step) {
                case 0:
                    if ((this.selectedDocumentType.id ?? 0) > 0 == false)
                        return false
                    
                    if (!this.document_issue_date)
                        return false
                    
                    break

                case 2:
                    if ((this.document_gross_value ?? 0 > 0) == false)
                        return false

                    if ((this.selectedPaymentType.id ?? 0 > 0) == false)
                        return false

                    return true

                default:
                    return true
            }
        },

        supplierNotEditable() {
            return (this.supplier.id ?? 0) > 0
        }
            
    },


    methods: {
        initialize() {
            this.$store.dispatch('currentUser/getCurrentUser')
            
            // this.document_issue_date = new Date().toISOString().slice(0, 10)

            const dateAthens = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Europe/Athens',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date());

            this.document_issue_date = dateAthens;

            axios.all([
                axios.get('/api/document-types/payment'),
                axios.get('/api/tax-authority/payment-types'),
            ]).then(
                axios.spread(
                (
                    documentTypesResponse, 
                    paymentTypesResponse,
                ) => {
                    this.documentTypes = documentTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
                    this.paymentTypes = paymentTypesResponse.data.filter(x => x.flag_credit == false)
            })).catch(error => { console.log(error) })
        },

        clearSupplierFields() {
            this.supplier = {
                country: {},
                tax_office: { },

            }
        },

        saveDocument() {
            this.saveButtonDisabled = true;

            let requestBody = {
                document_type_id: this.selectedDocumentType.id,
                document_series_id: this.selectedSeries.id,
                document_number: this.document_number,
          
                issue_date: this.document_issue_date,
                supplier_id: this.supplier.id,
                gross_value: this.document_gross_value,

                payment_type_id: this.selectedPaymentType.id,

                comments: this.comments
            }

            axios.post('/api/documents/payment', requestBody)
            .then(_ => { 
                this.$router.push({ name: 'paymentdocuments' })
            })
            .catch(error => { 
                console.log(error)
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        const errs = { supplier: {} }
                        for (const [key, val] of Object.entries(error.response.data.errors)) {
                            const parts = key.split('.')
                            if (parts.length === 2) {
                                if (!errs[parts[0]]) errs[parts[0]] = {}
                                errs[parts[0]][parts[1]] = val
                            } else {
                                errs[key] = val
                            }
                        }
                        this.allerrors = errs
                        const messages = Object.values(error.response.data.errors).flat().join('<br>')
                        this.$swal({ icon: 'error', title: 'Σφάλμα', html: messages })
                    } else if (error.response.data.message) {
                        this.$swal({ icon: 'error', title: 'Σφάλμα', text: error.response.data.message })
                    }
                }
              })
            .finally( () => { this.saveButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {
            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
            } else if (response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                //country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_office: data.tax_office ?? { } ,
                country: data.country ?? { }
                // tax_office: data.tax_office
            }
        }
            //.catch(error => { console.log(error) })
    }
}
</script>

<style scoped>

</style>